import Link from "next/link";

import React from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";

import { isPast } from "date-fns";
import format from "date-fns/format";
import { Entity } from "models/entity";

import { faCheck } from "@fortawesome/free-solid-svg-icons/faCheck";
import { faQuestionCircle } from "@fortawesome/free-solid-svg-icons/faQuestionCircle";

import FontAwesomeIcon from "components/FontAwesomeIcon";
import { useApi } from "hooks/useApi";
import { baseFetcher } from "utils/baseFetcher";

import { estimatesUrl } from "../utils";

interface NextEarningTextProps {
  entity: Entity;
}

const NextEarningText = ({ entity }: NextEarningTextProps) => {
  const { data: estimatesData, isValidating } = useApi(
    estimatesUrl(entity.id),
    baseFetcher,
    {
      revalidateOnFocus: false,
      revalidateOnReconnect: false,
    }
  );

  if (isValidating || !estimatesData) return <div className="md:h-[20px]" />;

  const { next_earn } = estimatesData || {};

  if (!next_earn?.date || isPast(new Date(next_earn?.date)))
    return <div className="md:h-[20px]" />;

  return (
    <Link
      href={`/entities/${entity.slug}/analytics?tab=estimates`}
      className="hover:underline flex"
    >
      <div className="text-[13px] md:text-[14px] space-x-[5px]">
        <span className="font-medium flex-1">Next Earnings:</span>
        <OverlayTrigger
          overlay={
            next_earn.status?.toLowerCase() === "confirmed" ? (
              <Tooltip>Confirmed Earnings Date</Tooltip>
            ) : next_earn.when ? (
              <></>
            ) : (
              <Tooltip>Estimated Earnings Date</Tooltip>
            )
          }
        >
          <span className="">
            {format(new Date(next_earn.date), "dd MMM yyyy")}{" "}
            {next_earn.status?.toLowerCase() === "confirmed" ? (
              <div className="inline-block">
                <FontAwesomeIcon
                  icon={faCheck}
                  className="text-bullish-green"
                />
              </div>
            ) : next_earn.when ? (
              `(${next_earn.when})`
            ) : (
              <div className="inline-block">
                <FontAwesomeIcon icon={faQuestionCircle} />
              </div>
            )}
          </span>
        </OverlayTrigger>
      </div>
    </Link>
  );
};

export default NextEarningText;
